import { apiClient, publicApiClient } from './axiosClient';
import { AxiosInstance } from 'axios';

/**
 * Get the appropriate API client based on whether authentication is required.
 *
 * @param requiresAuth - Whether the endpoint requires authentication (default: true)
 * @returns The appropriate axios instance
 */
export const getClient = (requiresAuth: boolean = true): AxiosInstance => {
  return requiresAuth ? apiClient : publicApiClient;
};

/**
 * API client for authenticated requests.
 * Automatically attaches token from store via interceptors.
 */
export const authenticatedApi = apiClient;

/**
 * API client for public/unauthenticated requests.
 * Used for login, registration, and other public endpoints.
 */
export const publicApi = publicApiClient;
